import { UNIDADE_MILHOES } from "../planejamento-controle.constants";

export const CANCELAR_TIPO_FORM_ID = "cancelar-tipo-obra-form";

export const CANCELAR_TIPO_TITLE = "Cancelar Tipo de Obra";
export const TIPO_A_CANCELAR_LABEL = "Tipo de Obra a cancelar";
export const TIPO_EM_CANCELAMENTO_LABEL = "Tipo de Obra selecionado";
export const ESCOPOS_TITLE = "Escopos macro que serão cancelados";
export const SERVICOS_MATERIAIS_TITLE = "Serviços e Materiais que serão cancelados";
export const SERVICOS_MATERIAIS_IMPEDIDO_TITLE = "Serviços e Materiais do Tipo de Obra";
export const VALOR_TOTAL_LABEL = "Valor total";
export const CARREGANDO_LABEL = "Carregando dados do cancelamento...";

export const COLUNA_ESCOPO = "Escopo macro";
export const COLUNA_CLASSIFICACAO = "Classificação";
export const COLUNA_DISTRIBUICAO = "Distribuição";
export const COLUNA_TOTAL = `Total (${UNIDADE_MILHOES.simbolo} ${UNIDADE_MILHOES.sufixo})`;
export const LINHA_TOTAL = "Total";
export const CLASSIFICACAO_SEM_DADO = "—";
export const DISTRIBUICAO_SEM_DADO = "—";

export const SUCESSOR_LABEL = "Novo Tipo de Obra dominante";
export const SUCESSOR_PLACEHOLDER = "Selecione o novo dominante";
export const SUCESSOR_SUGERIDO_SUFIXO = "(sugerido)";
export const SUCESSOR_OBRIGATORIO = "Selecione o novo Tipo de Obra dominante.";
/** Figma 16041:820239. */
const SUCESSOR_AJUDA_BASE =
  "Sugerido pela ordem de dominância, entre os Tipos de Obra do Centro de custo principal.";
export const SUCESSOR_AJUDA = `${SUCESSOR_AJUDA_BASE} A troca só vale depois da aprovação do cancelamento.`;
/** FEL-0 efetiva na hora: sem a frase da aprovação. */
export const SUCESSOR_AJUDA_FEL_ZERO = SUCESSOR_AJUDA_BASE;
/** Figma 15555:906751: um só candidato, seletor preenchido e travado. */
const SUCESSOR_UNICO_AJUDA_BASE = "Único Tipo de Obra elegível no Centro de custo principal.";
export const SUCESSOR_UNICO_AJUDA = `${SUCESSOR_UNICO_AJUDA_BASE} A troca só vale depois da aprovação do cancelamento.`;
export const SUCESSOR_UNICO_AJUDA_FEL_ZERO = SUCESSOR_UNICO_AJUDA_BASE;
export const SUCESSOR_DIFERENTE_AJUDA = (sugerido: string) =>
  `Diferente da sugestão (${sugerido}). Explique a escolha na justificativa.`;

export const JUSTIFICATIVA_GERAL_LABEL = "Justificativa";
export const CANCELAR_LABEL = "Voltar";
export const CONFIRMAR_LABEL = "Solicitar cancelamento";
/** Em FEL-0 o cancelamento é efetivado na hora. */
export const CONFIRMAR_EFETIVAR_LABEL = "Cancelar Tipo de Obra";

export const DESTINO_DEVOLVER_LABEL = "Devolver valor projetado";
export const DESTINO_DEVOLVER_AJUDA = "O valor projetado deste Tipo de Obra é devolvido à empresa.";
// "Redistribuir" vem do comentário do cliente; o Figma ainda mostra "Manter na Obra", cuja ajuda é reaproveitada.
export const DESTINO_REDISTRIBUIR_LABEL = "Redistribuir entre os demais Tipos de Obra";
export const DESTINO_REDISTRIBUIR_AJUDA =
  "Depois da aprovação, o Tipo de Obra fica como Cancelado Aguardando Destino do Saldo, e é criada uma pendência de redistribuição do saldo.";

/** Figma 15557:939544: antes de escolher o destino. */
export const IMPACTO_NEUTRO =
  "Os escopos macro e a projeção de Serviços e Materiais deste Tipo de Obra também serão cancelados. O efeito no total da Obra depende do destino do valor projetado.";
/** MS01 da HU 2717 e Figma 15555:906751. */
export const IMPACTO_DEVOLVER =
  "Os escopos macro e a projeção de Serviços e Materiais deste Tipo de Obra também serão cancelados. Depois da aprovação, o valor sai do Outlook da Obra.";
/** Figma 16110:323958. */
export const IMPACTO_REDISTRIBUIR =
  "Os escopos macro e a projeção de Serviços e Materiais deste Tipo de Obra também serão cancelados. Depois da aprovação, o Tipo de Obra fica como Cancelado Aguardando Destino do Saldo, e é criada uma pendência de redistribuição do saldo.";
/** Figma 17212:603165 (FEL-4 em diante). */
export const DESTINO_REDISTRIBUIR_CONTINGENCIA_AJUDA = "O valor vai para a contingência da Obra.";
export const IMPACTO_REDISTRIBUIR_CONTINGENCIA =
  "Os escopos macro e a projeção de Serviços e Materiais deste Tipo de Obra também serão cancelados. Depois da aprovação, o valor projetado deste Tipo de Obra vai para a contingência da Obra.";
/** Em FEL-0 não há destino: a efetivação tira o valor do Outlook (MS01). */
export const IMPACTO_FEL_ZERO =
  "Os escopos macro e a projeção de Serviços e Materiais deste Tipo de Obra também serão cancelados, e o valor sai do Outlook da Obra.";

export const DOMINANTE_MESSAGE = (atual: string, sucessor: string) =>
  `${atual} é o Tipo de Obra dominante desta Obra. Ao cancelar, o dominante passa a ser ${sucessor}.`;
// Pendência de texto (PO): a HU pede o caso sem candidato, sem a mensagem.
export const DOMINANTE_SEM_SUCESSOR_MESSAGE = (atual: string) =>
  `${atual} é o Tipo de Obra dominante desta Obra. Sem Tipo de Obra elegível no Centro de Custo principal, a Obra ficará sem dominante.`;
// Figma 5.6 (15555:1865124); o 409 do core (MSG_ULTIMO_TIPO_OBRA) leva ao mesmo estado.
export const ULTIMO_TIPO_MESSAGE = (tipo: string, obra: string) =>
  `${tipo} é o único Tipo de Obra da ${obra}. Para retirá-lo, é preciso cancelar a Obra.`;
export const ULTIMO_TIPO_PADRAO = /último Tipo de Obra/i;

export const CANCELADO_MESSAGE = (rotulo: string) => `${rotulo} cancelado.`;
// Adaptação do texto padrão da 2714 (MS04); pendência de texto (PO).
export const ENVIADO_PARA_APROVACAO = (rotulo: string) =>
  `Cancelamento de ${rotulo} solicitado e aguardando aprovação.`;
